import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <MediaSection />
        <CarouselSection />
        <UpdatesSection />
        <CommentsSection />
        <FaqSection />
        <RankingSection />
        <AboutSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}